module.exports = __webpack_public_path__ + "img/08.150cce9d.jpg";